var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeftTiny = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.872 7.459 7.36.773a.75.75 0 0 1 1.076 1.044L2.438 8l5.998 6.183a.75.75 0 0 1 .058.977l-.074.083a.75.75 0 0 1-1.06-.016L.872 8.541a.75.75 0 0 1-.211-.542.75.75 0 0 1 .211-.54"
})));
export default SvgArrowLeftTiny;